// cart
export const ADD_TO_CART = 'ADD_TO_CART';
export const INCREASE = 'INCREASE';
export const DECREASE = 'DECREASE';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const CLEAR_CART = 'CLEAR_CART';
export const GET_TOTALS = 'GET_TOTALS';
export const CLEAR_ALERT = 'CLEAR_ALERT';

// products
export const LOADING = 'LOADING';
export const DISPLAY_ITEMS = 'DISPLAY_ITEMS';
export const ERROR = 'ERROR';
export const SEARCH_VALUE = 'SEARCH_VALUE';
